var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createAction, createReducer } from '@reduxjs/toolkit';
export var initialState = {
    dealerCode: '',
    dealerName: '',
};
export var setDealerData = createAction('dealer/setDealerData');
export var resetDealerData = createAction('dealer/resetDealerData');
var dealer = createReducer(initialState, function (builder) {
    builder
        .addCase(setDealerData, function (state, action) {
        var _a, _b, _c;
        var newDealer = action.payload;
        return (newDealer === null || newDealer === void 0 ? void 0 : newDealer.dealerCode) && (newDealer === null || newDealer === void 0 ? void 0 : newDealer.dealerName)
            ? __assign(__assign({}, newDealer), { provinceCode: (_a = newDealer === null || newDealer === void 0 ? void 0 : newDealer.provinceCode) !== null && _a !== void 0 ? _a : (_c = (_b = newDealer === null || newDealer === void 0 ? void 0 : newDealer.location) === null || _b === void 0 ? void 0 : _b.province) === null || _c === void 0 ? void 0 : _c.abbreviation }) : state;
    })
        .addCase(resetDealerData, function () { return initialState; });
});
export var selectDealer = function (state) { return state.dealer; };
export var selectDealerProvinceCode = function (state) { var _a; return (_a = state.dealer) === null || _a === void 0 ? void 0 : _a.provinceCode; };
export default dealer;
